/** Matches backend copy from ensureMaxSubscribersNotReached and older "maxSubscribers" wording. */
const MAX_SUBSCRIBERS_ERROR_PATTERNS = ['maximum number of subscribers', 'maxsubscribers'] as const;

export const OPERATOR_MAX_SUBSCRIBERS_CAP_MESSAGE =
  'This plan has reached its subscriber limit. Raise Max Subscribers or remove a member, then try again.';

export const CUSTOMER_MAX_SUBSCRIBERS_CAP_MESSAGE =
  'This parking plan is full. Contact your plan administrator.';

export function isMaxSubscribersCapError(message?: string | null): boolean {
  if (typeof message !== 'string') {
    return false;
  }
  const normalized = message.toLowerCase();
  return MAX_SUBSCRIBERS_ERROR_PATTERNS.some((pattern) => normalized.includes(pattern));
}

export function operatorMaxSubscribersCapMessage(raw?: string | null): string | undefined {
  if (!raw) {
    return undefined;
  }
  return isMaxSubscribersCapError(raw) ? OPERATOR_MAX_SUBSCRIBERS_CAP_MESSAGE : raw;
}

export function customerMaxSubscribersCapMessage(
  raw?: string | null,
  fallback = 'Could not redeem the parking subscription',
): string {
  if (isMaxSubscribersCapError(raw)) {
    return CUSTOMER_MAX_SUBSCRIBERS_CAP_MESSAGE;
  }
  return raw || fallback;
}
